import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { get as _get } from 'lodash';

import {
  hideNotification,
  showNotification,
} from 'actions';

import { currencyFormat } from 'utils/currencyFormat';

import localize from 'components/Localize/Localize';
import Notification from 'components/Notification/Notification';

import translations from './translations';

class CreditCampaignBanner extends React.Component {
  componentDidMount() {
    if (this.props.landedCreditCampaign && !this.props.isLoggedIn) {
      this.props.showNotification(`creditCampaign${this.props.landedCreditCampaign.id}Banner`, `credit-campaign`, this.getMessage(this.props.landedCreditCampaign));
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.landedCreditCampaign && nextProps.landedCreditCampaign !== this.props.landedCreditCampaign && !this.props.isLoggedIn) {
      nextProps.showNotification(`creditCampaign${nextProps.landedCreditCampaign.id}Banner`, `credit-campaign`, this.getMessage(nextProps.landedCreditCampaign));
    }
  }

  getCampaignDismissed() {
    if (!window.localStorage || !window.sessionStorage) {
      return false;
    }

    return Boolean(JSON.parse(window.localStorage.getItem(`creditCampaign${this.props.landedCreditCampaign.id}Dismissed`)));
  }

  setCampaignDismissed() {
    if (!window.localStorage || !window.sessionStorage) {
      return false;
    }

    window.localStorage.setItem(`creditCampaign${this.props.landedCreditCampaign.id}Dismissed`, true);
  }

  getMessage(campaign) {
    let message = ``;

    if (campaign[`existing_users_allowed`] && campaign[`new_users_allowed`]) {
      message = this.props.t.messageLogInOrSignUp;
    } else if (campaign[`existing_users_allowed`] && !campaign[`new_users_allowed`]) {
      message = this.props.t.messageLogIn;
    } else if (!campaign[`existing_users_allowed`] && campaign[`new_users_allowed`]) {
      message = this.props.t.messageSignUp;
    }

    const amount = currencyFormat(campaign.amount, this.props.locale, false);
    const redeemURL = `/redeem/${campaign.token}`;

    message = message.replace(/\[amount\]/g, amount);
    message = message.replace(/\[redeem\]/g, redeemURL);

    return message;
  }

  render() {
    if (!this.props.landedCreditCampaign || this.getCampaignDismissed()) {
      return null;
    }

    return (
      <Notification
        keyName={`creditCampaign${this.props.landedCreditCampaign.id}Banner`}
        onClose={this.setCampaignDismissed.bind(this)}
      />
    );
  }
}

CreditCampaignBanner.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  landedCreditCampaign: PropTypes.object,
  t: PropTypes.shape({
    messageLogIn: PropTypes.string.isRequired,
    messageSignUp: PropTypes.string.isRequired,
    messageLogInOrSignUp: PropTypes.string.isRequired,
  }),
};

const mapStateToProps = (state) => ({
  isLoggedIn: _get(state, `session.loggedIn`),
  landedCreditCampaign: _get(state, `session.landedCreditCampaign`),
});

const mapDispatchToProps = (dispatch) => ({
  hideNotification: (key) => {
    dispatch(hideNotification(key));
  },
  showNotification: (key, type, message) => {
    dispatch(showNotification(key, { type, message }));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(localize(CreditCampaignBanner, translations));
